import { useEffect, useState } from "react";
import { cognitoUserInfo } from "../helpers/userHelper";
import { usePromiseEffect } from "../helpers/promiseEffect";
import ICurrentUser from "../entities/helper/ICurrentUser";
import { useLocalStorage } from "@uidotdev/usehooks";

interface IAccessErrorProps {
  message: string;
}
const AccessError = ({ message }: IAccessErrorProps) => {
  const [currentUser, setCurrentUser] = useState<ICurrentUser | undefined>();
  const [, saveRedirectUrlLogin] = useLocalStorage<string>("redirectUrlLogin", "/");

  usePromiseEffect(async () => {
    let currUser: ICurrentUser = await cognitoUserInfo();
    setCurrentUser(currUser);
  }, []);

  useEffect(() => {
    if (currentUser?.email === "") {
      saveRedirectUrlLogin(window.location.href);
      window.location.href = "/";
    }
  }, [currentUser]);

  return (
    <div className="row mb-4 mx-4 mt-7rem">
      <div className="col-12 mt-4">
        <div className="rounded bg-white p-2 shadow">
          <div className="container text-center">
            <h4 className="my-4 rounded">{message}</h4>
            <p className="mt-0 mb-4 rounded fs-5 fw-medium">
              {currentUser?.email === "" ? "Por favor, inicie sesión con su cuenta." : "Por favor, comunicarse con el administrador."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessError;
